export class EventHandler<T> {
  private listeners: Array<(data: T) => void>;
  constructor() {
    this.listeners = [];
  }

  public addListener(callback: (data: T) => void) {
    this.listeners.push(callback);
  }

  public trigger(data: T) {
    this.listeners.forEach((listener) => {
      listener(data);
    });
  }

  public clearListeners() {
    this.listeners = [];
  }
}
